import { jsx as x, jsxs as j } from "react/jsx-runtime";
import { c as Z } from "./index-65016bfa.mjs";
import A, { useRef as G, useMemo as Y, useContext as q, useState as Q, useEffect as M, useCallback as de } from "react";
import k, { css as W } from "styled-components";
import { Icon as J } from "./icon.js";
import { L as ee } from "./label-33699561.mjs";
import { ProgressBar as me } from "./progressBar.js";
import { u as I } from "./uniqueId-321287e8.mjs";
import { BREAKPOINTS as Se } from "@fcamna/shared-component-foundations";
import { u as ge } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { u as ye } from "./useWindowSize-88e90e04.mjs";
import { Button as Fe } from "./button.js";
import { InLineAlert as Ee } from "./inLineAlert.js";
import { S as De } from "./screenReaderOnly-fd82ed96.mjs";
import { u as te } from "./useAccessibilityProps-2f24cf29.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "@fcamna/shared-icons";
import "./popupTip.js";
import "react-dom";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./Aria-f5e019e2.mjs";
import "./closeButton.js";
import "./iconButton.js";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./divider.js";
import "./focusTrap.js";
import "./useClient-0bbce34e.mjs";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
import "./tooltip.js";
import "./helperText-d9646f54.mjs";
const Ue = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], be = (r) => {
  let y = 0, f = parseInt(r, 10) || 0;
  for (; f >= 1e3 && ++y; )
    f = f / 1e3;
  return f.toFixed(f < 10 && y > 0 ? 2 : 1) + " " + Ue[y];
}, b = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  PROGRESS: "PROGRESS",
  QUEUED: "QUEUED",
  IDLE: "IDLE"
}, X = A.createContext({}), ft = ({ children: r }) => {
  const [y, f] = A.useState({}), a = G({}), d = G({}), m = (l, P) => {
    if (a.current) {
      if (!a.current[l])
        return;
      a.current[l](P);
    }
  }, D = (l, P) => {
    a.current && (a.current[l] || (a.current[l] = P));
  }, i = (l) => {
    if (a.current) {
      if (!a.current[l])
        return;
      a.current[l]({}, !0);
    }
  }, R = (l) => {
    if (a.current) {
      if (!a.current[l])
        return;
      a.current[l] = null, delete a.current[l];
    }
  }, C = (l, P) => {
    d.current && (d.current[l] || (d.current[l] = P));
  }, N = (l) => {
    if (d.current) {
      if (!d.current[l])
        return;
      d.current[l] = null, delete d.current[l];
    }
  }, O = (l) => {
    if (d.current)
      return d.current[l] ? d.current[l] : null;
  }, v = Y(
    () => ({
      fileDispatch: m,
      fileSubscribe: D,
      fileUnsubscribe: R,
      clearQueue: i
    }),
    []
  ), L = Y(
    () => ({
      setFileData: C,
      getFileData: O,
      removeFileData: N
    }),
    []
  );
  return /* @__PURE__ */ x(
    X.Provider,
    {
      value: {
        uploadStatus: y,
        setUploadStatus: f,
        fileEvent: v,
        fileData: L
      },
      children: r
    }
  );
}, dt = () => {
  const { fileEvent: r, setUploadStatus: y } = A.useContext(X);
  return {
    clearStatus: (a) => {
      y((d) => {
        var i;
        const m = { ...d[a] };
        return m.files = ((i = m == null ? void 0 : m.files) == null ? void 0 : i.filter((R) => R.status === b.PROGRESS || R.status === b.QUEUED)) || [], { ...d, [a]: m };
      }), r.clearQueue(a);
    }
  };
}, Re = k.div`
  &.FileProgress--container {
    ${({
  theme: {
    components: { fileUpload: r }
  }
}) => W(r.StyledFileProgressContainer)};
  }
`, he = k.span`
  &.FileProgress--icon {
    ${({
  theme: {
    components: { fileUpload: r }
  }
}) => W(r.StyledIconWrapper)};
  }
`, xe = k.div`
  &.FileProgress-wrapper {
    ${({
  theme: {
    components: { fileUpload: r }
  }
}) => W(r.StyledProgressWrapper)};
  }
`, mt = ({ uniqueIdentifier: r, className: y, retryHandler: f, deleteHandler: a }) => {
  const { setUploadStatus: d, fileEvent: m, fileData: D } = q(X), i = G({}), [R, C] = Q({});
  M(() => (m.fileSubscribe(r, (o, p = !1) => {
    p ? C((c) => {
      const u = { ...c };
      return Object.keys(c).forEach((t) => {
        var n, U;
        ((n = u[t]) == null ? void 0 : n.status) === b.PROGRESS || ((U = u[t]) == null ? void 0 : U.status) === b.QUEUED || delete u[t];
      }), u;
    }) : l(o, I());
  }), () => {
    m.fileUnsubscribe(r);
  }), [r]);
  const N = de((o, p) => {
    var u;
    const c = D.getFileData(r);
    return {
      [p]: {
        files: (u = Object.keys(o)) == null ? void 0 : u.map((t) => {
          var U, B, T;
          const n = o[t];
          return n && (c != null && c.skipUpload ? {
            fileId: t,
            fileObj: n.file
          } : {
            fileId: t,
            name: (U = n == null ? void 0 : n.file) == null ? void 0 : U.name,
            size: (B = n == null ? void 0 : n.file) == null ? void 0 : B.size,
            type: (T = n == null ? void 0 : n.file) == null ? void 0 : T.type,
            status: n == null ? void 0 : n.status,
            errorMessage: n == null ? void 0 : n.errorMessage,
            responseObj: n == null ? void 0 : n.responseObj
          });
        }).filter((t) => t !== null),
        changeKey: I()
      }
    };
  }, []), O = (o) => {
    setTimeout(() => {
      d(N(o, r));
    }, 100);
  }, v = (o, p, c, u, t, n, U, B) => {
    if (!o)
      return;
    const T = new FormData();
    T.append(t, o), Object.keys(U).forEach((S) => {
      T.append(S, U[S]);
    });
    const $ = new XMLHttpRequest();
    $.open(u, c, !0), Object.keys(n).forEach((S) => {
      $.setRequestHeader(S, n[S]);
    }), $.upload.onprogress = async function(S) {
      const E = Math.ceil(S.loaded / S.total * 100);
      let F = null;
      C((w) => {
        var z;
        const g = {
          ...w,
          [p]: {
            ...w[p],
            progress: E,
            status: b.PROGRESS
          }
        };
        return ((z = w[p]) == null ? void 0 : z.status) !== b.PROGRESS && (F = { ...g }), g;
      }), F && d(N(F, r));
    }, $.onload = async function() {
      var S;
      if (this.status >= 200 && this.status <= 299) {
        let E = {};
        C((F) => (E = {
          ...F,
          [p]: {
            ...F[p],
            progress: 100,
            errorMessage: null,
            status: b.SUCCESS,
            responseObj: this.response
          }
        }, O(E), E));
      } else {
        let E = "Something went wrong";
        try {
          E = (S = JSON.parse(this.response)) == null ? void 0 : S.message;
        } catch {
          console.warn("Response is not a valid json");
        }
        C((F) => {
          const w = {
            ...F,
            [p]: {
              ...F[p],
              progress: 100,
              errorMessage: E,
              status: b.ERROR,
              responseObj: this.response
            }
          };
          return O(w), w;
        });
      }
    }, $.onerror = async function() {
      const S = "Something went wrong";
      let E = {};
      C((F) => (E = {
        ...F,
        [p]: {
          ...F[p],
          progress: 100,
          errorMessage: S,
          status: b.ERROR,
          responseObj: this.response
        }
      }, O(E), E));
    }, $.ontimeout = async function() {
      const S = "Request timed out!";
      let E = {};
      C((F) => (E = {
        ...F,
        [p]: {
          ...F[p],
          progress: 100,
          errorMessage: S,
          status: b.ERROR,
          responseObj: this.response
        }
      }, O(E), E));
    }, $.withCredentials = B, $.send(T);
  }, L = (o) => {
    var c, u;
    if (!((c = R[o]) != null && c.file))
      return;
    const p = D.getFileData(r);
    v(
      (u = R[o]) == null ? void 0 : u.file,
      o,
      p.url,
      p.method,
      p.param,
      p.headers,
      p.body,
      p.credentials
    );
  }, l = async (o, p) => {
    if (!o)
      return;
    const c = D.getFileData(r);
    (async function(t) {
      let n = {};
      C((U) => (n = {
        ...U,
        [t]: {
          file: o,
          progress: 0,
          status: c.skipUpload ? b.IDLE : b.QUEUED,
          errorMessage: null
        }
      }, O(n), n)), c.skipUpload || v(o, t, c.url, c.method, c.param, c.headers, c.body, c.credentials);
    })(p);
  }, P = async (o) => {
    if (!o)
      return;
    const p = { ...R };
    p[o] && (p[o] = null, delete p[o]), i.current && i.current[o] && i.current[o] && (i.current[o] = null, delete i.current[o]), C(p), O(p);
  }, V = Y(() => {
    var c;
    const o = D.getFileData(r);
    return (c = Object.keys(R)) == null ? void 0 : c.map((u) => {
      var F, w;
      if (!u)
        return null;
      const t = R[u];
      if (!t)
        return null;
      const n = be(`${(F = t == null ? void 0 : t.file) == null ? void 0 : F.size}`), U = `${((w = t == null ? void 0 : t.file) == null ? void 0 : w.name) || ""} (${n})`, B = t.status === b.SUCCESS ? "success" : t.status === b.ERROR ? "error" : "default", T = B === "error" ? t.errorMessage : "", $ = () => {
        if (i.current) {
          let g = i.current[u];
          const z = t.status === b.QUEUED ? "Queued" : t.status === b.PROGRESS ? `${t.progress}%` : "", H = `${t.progress}_${B}_${t.errorMessage}`;
          return (!g || g && g.compareKey !== H) && (g = {
            compareKey: H,
            progressBar: o.skipUpload ? /* @__PURE__ */ x(
              ee,
              {
                labelProp: {
                  label: U
                },
                trailingText: "Ready"
              }
            ) : /* @__PURE__ */ x(
              me,
              {
                accessibilityOptions: {
                  ariaValuText: t.status === "default" ? "progressing" : t.status,
                  ariaValuenow: t.progress,
                  ariaBusy: !["success", "error"].includes((t == null ? void 0 : t.status) || "")
                },
                labelProp: {
                  label: U
                },
                maxValue: 100,
                progressValue: t.progress,
                status: B,
                helperTextProp: {
                  defaultProp: {
                    helperText: T ?? ""
                  }
                },
                trailingText: z
              },
              I()
            )
          }, i.current[u] = g), g.progressBar;
        }
      }, S = o.skipUpload ? !1 : t.status !== b.SUCCESS && t.status !== b.ERROR, E = t.status === b.ERROR;
      return /* @__PURE__ */ j(
        xe,
        {
          className: Z(["FileProgress-wrapper"]),
          children: [
            $(),
            /* @__PURE__ */ j(he, { className: Z(["FileProgress--icon"]), children: [
              E && /* @__PURE__ */ x(
                J,
                {
                  name: "undo",
                  role: "button",
                  size: "l",
                  "aria-label": "retry",
                  tabIndex: 0,
                  onKeyDown: (g) => {
                    (g.code === "Enter" || g.code === "Space") && (L(u), f && f(g, { ...t, fileId: u }));
                  },
                  onClick: (g) => {
                    L(u), f && f(g, { ...t, fileId: u });
                  }
                }
              ),
              /* @__PURE__ */ x(
                J,
                {
                  name: "delete",
                  role: "button",
                  "aria-disabled": S,
                  "aria-label": "trash",
                  tabIndex: S ? -1 : 0,
                  size: "l",
                  className: Z({ disabled: S }),
                  onKeyDown: (g) => {
                    (g.code === "Enter" || g.code === "Space") && (S || (P(u), a && a(g, { ...t, fileId: u })));
                  },
                  onClick: (g) => {
                    S || (P(u), a && a(g, { ...t, fileId: u }));
                  }
                }
              )
            ] })
          ]
        },
        u
      );
    });
  }, [R]);
  return V.length > 0 ? /* @__PURE__ */ x(
    Re,
    {
      className: Z("FileProgress--container", y),
      "aria-label": `${r}-progress-bar`,
      children: V.map((o) => o)
    }
  ) : null;
}, Ce = k.div`
  &.FileUpload--container {
    ${({
  theme: {
    components: { fileUpload: r }
  }
}) => W(r.StyledFileUploadContainer)};
  }
`, ve = k.div`
  &.FileUpload--header {
    ${({
  theme: {
    components: { fileUpload: r }
  }
}) => W(r.StyledFileHeader)};
  }
`, Oe = k.p`
  &.FileUpload--header-helperText {
    ${({
  theme: {
    components: { fileUpload: r }
  }
}) => W(r.StyledFileHeaderHelperText)};
  }
`, Te = k.div`
  &.FileUpload--dropZoneWrapper {
    ${({
  theme: {
    components: { fileUpload: r }
  }
}) => W(r.StyledDropZoneWrapper)};
  }
`, re = k.div``, $e = k.div`
  &.FileUpload--dropZoneIcon {
    ${({
  theme: {
    components: { fileUpload: r }
  }
}) => W(r.StyledDropZoneIconWrapper)};
  }
`, Pe = k.p`
  &.FileUpload--dropZoneTextwrapper {
    ${({
  theme: {
    components: { fileUpload: r }
  }
}) => W(r.StyledDropzoneTextwrapper)};
  }
`, se = ({ helperText: r, className: y, labelProp: f, infoProp: a, trailingText: d }) => /* @__PURE__ */ j(ve, { className: Z(["FileUpload--header", y]), children: [
  /* @__PURE__ */ x(
    ee,
    {
      labelProp: {
        showRequiredIndicator: !1,
        ...f
      },
      infoProp: {
        infoText: "",
        infoType: "tooltip",
        popupTipHeader: "Info",
        ...a
      },
      trailingText: d
    }
  ),
  r && /* @__PURE__ */ x(Oe, { className: Z(["FileUpload--header-helperText"]), children: r })
] }), oe = ({
  buttonLabel: r = "Choose Files To Upload",
  onClick: y,
  _disabled: f = !1,
  ariaLabelledBy: a,
  className: d,
  accessibilityOptions: m = {},
  icon: D
}) => {
  const { width: i } = ye(), R = te("button", {
    ...m,
    ariaDisabled: f,
    tabIndex: f ? -1 : 0
  });
  return /* @__PURE__ */ x(
    Fe,
    {
      size: i > Se.tabletMin ? "medium" : "small",
      variant: "outline",
      color: "primary",
      className: `btn ${d}`,
      onClick: y,
      tabIndex: 0,
      isDisabled: f,
      "aria-labelledby": a,
      leftIcon: D == null ? void 0 : D.leadingIcon,
      rightIcon: D == null ? void 0 : D.trailingIcon,
      ...R,
      children: r
    }
  );
}, ne = ({
  icon: r = /* @__PURE__ */ x(J, { name: "cloud" }),
  iconName: y = "cloud",
  children: f,
  _onClick: a,
  _handleDrop: d,
  _disabled: m = !1,
  className: D,
  accessibilityOptions: i = { ariaLabel: "Browse or drag files here" }
}) => {
  const R = te("button", {
    ...i,
    ariaDisabled: m
  });
  return /* @__PURE__ */ j(
    Te,
    {
      onDragOver: (v) => {
        v.preventDefault();
      },
      onDrop: (v) => !m && d && d(v),
      onKeyDown: (v) => {
        (v.code === "Enter" || v.code === "Space") && a && !m && a();
      },
      className: Z(["FileUpload--dropZoneWrapper", D, { "FileUpload--dropZoneWrapper--disabled": m }]),
      ...R,
      tabIndex: m ? -1 : 0,
      children: [
        /* @__PURE__ */ x($e, { className: Z(["FileUpload--dropZoneIcon", { "FileUpload--dropZoneIcon--disabled": m }]), children: y ? /* @__PURE__ */ x(J, { name: y }) : r }),
        /* @__PURE__ */ x(
          Pe,
          {
            className: Z(["FileUpload--dropZoneTextwrapper", { "FileUpload--dropZoneTextwrapper--disabled": m }]),
            onClick: () => a && !m && a(),
            children: f
          }
        )
      ]
    }
  );
}, _ = ({
  maxFilesCount: r = 10,
  maxFileSize: y,
  allowedFileType: f,
  disabled: a = !1,
  className: d = "",
  fileUploadUrl: m = "",
  uploadMethod: D = "POST",
  uniqueIdentifier: i = "",
  skipUpload: R = !1,
  uploadParamName: C = "file",
  children: N,
  filesHeaders: O = {},
  withCredentials: v = !1,
  requestBody: L = {},
  alertMessages: l = {
    invalidFile: "Please provide valid file types.",
    maxSize: "Files can be up to"
  },
  uploadStatusCallback: P
}) => {
  const V = ge({ label: "File Upload" }), o = G(null), p = G(null), [c, u] = Q([]), [t, n] = Q(null), { uploadStatus: U, fileEvent: B, fileData: T } = q(X), [$, S] = Q(""), [E, F] = Q("");
  M(() => {
    U[i] && U[i].changeKey !== $ && (S(U[i].changeKey), P && P(U[i].files));
  }, [U]), M(() => {
    const s = {
      url: m,
      method: D,
      param: C,
      headers: O,
      credentials: v,
      skipUpload: R,
      body: L
    };
    return T.setFileData(i, s), () => {
      T.removeFileData(i);
    };
  }, [m, i, D, C, v, O, T, R]);
  const w = (s) => {
    const e = s - r;
    n((l == null ? void 0 : l.maxFileCount) || `You can upload up to ${r} files. Remove ${e} file(s).`);
  }, g = (s) => {
    let e = !0;
    return y && y * 1e3 * 1e3 < s.size && (n(`${(l == null ? void 0 : l.maxSize) || "Files can be up to"} ${y}MB.`), e = !1), f && f.length > 0 && !f.includes(s.type) && (n((l == null ? void 0 : l.invalidFile) || "Please provide valid file types."), e = !1), e;
  }, z = (s) => {
    const e = c.length;
    let h = !0;
    e > 0 && (e > r ? (w(e), h = !1) : s == null || s.forEach((K) => {
      K && (h = h && g(K));
    })), h && (s == null || s.forEach((K) => {
      K && B.fileDispatch(i, K);
    }));
  };
  M(() => {
    var s;
    if (z(c), c.length) {
      const e = c.length === 1 ? `${c[0].name}  Selected` : `${c.length} files Selected`;
      F(e);
    }
    (s = p.current) == null || s.reset();
  }, [c]);
  const H = (s) => {
    var e;
    if ((e = s == null ? void 0 : s.target) != null && e.files) {
      const h = Array.from(s.target.files).filter((K) => !!K);
      u(h);
    }
  }, ae = (s) => {
    s.preventDefault(), n(null), u(Array.from(s.dataTransfer.files));
  }, le = Y(() => t ? /* @__PURE__ */ x(
    Ee,
    {
      variant: "error",
      body: t
    }
  ) : null, [t]), pe = (s, e) => A.cloneElement(s, {
    // Adding callback for file upload input change
    onClick: () => {
      var h;
      (h = o == null ? void 0 : o.current) == null || h.click(), e.onClick && e.onClick();
    },
    _disabled: a
  }), ce = (s, e) => A.cloneElement(s, {
    _onClick: () => {
      var h;
      (h = o == null ? void 0 : o.current) == null || h.click(), e._onClick && e._onClick();
    },
    // Adding callback for file upload drop event
    _handleDrop: ae,
    _disabled: a
  }), ue = (s, e) => A.cloneElement(s, {
    helperText: e
  }), ie = (s) => s != null && s.helperText ? (s == null ? void 0 : s.helperText) === "DEFAULT" ? `Upload up to ${r} files. ${y ? `Files can be up to ${y}MB.` : ""}` : s == null ? void 0 : s.helperText : null, fe = (s) => A.Children.map(s, (e) => {
    if (e && A.isValidElement(e))
      if ((e == null ? void 0 : e.type) === oe) {
        const h = e == null ? void 0 : e.props;
        return pe(e, h);
      } else if ((e == null ? void 0 : e.type) === ne) {
        const h = e == null ? void 0 : e.props;
        return ce(e, h);
      } else {
        if ((e == null ? void 0 : e.type) === re)
          return le;
        if ((e == null ? void 0 : e.type) === se) {
          const h = e == null ? void 0 : e.props, K = ie(h);
          return ue(e, K);
        }
      }
    return e;
  });
  return /* @__PURE__ */ j(
    Ce,
    {
      className: Z("FileUpload--container", d),
      ...V,
      children: [
        fe(N),
        /* @__PURE__ */ x("form", { ref: p, children: /* @__PURE__ */ x(
          "input",
          {
            id: i,
            ref: o,
            type: "file",
            multiple: !0,
            hidden: !0,
            onChange: (s) => {
              H(s), n(null);
            }
          }
        ) }),
        /* @__PURE__ */ x(De, { "aria-live": "assertive", children: c.length && E })
      ]
    }
  );
};
_.Button = oe;
_.DropZone = ne;
_.Alert = re;
_.Header = se;
export {
  mt as FileProgress,
  _ as FileUpload,
  ft as FileUploadProvider,
  b as UPLOAD_STATUS,
  dt as useFileUploadContext
};
